import './App.css';
import Header from './components/Header/Header';
import WorkExperience from './components/WorkExperience/WorkExperience';
import OpenSource from './components/OpenSource/OpenSource';
import TechnicalWriting from './components/TechnicalWriting/TechnicalWriting';
import Navbar  from './components/NavigationBar/NavigationBar';
import ScrollToTop from './components/NavigationBar/ScrollToTop';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar/>
        <ScrollToTop/>
        <Routes>
            <Route path="/" element={Header} />
            <Route path="/work-experience" element={WorkExperience} />
            <Route path="/open-source" element={OpenSource} />
            <Route path="/technical-writing" element={TechnicalWriting} />
          </Routes>
      </Router>
      
    </div>
  );
}

export default App;
